import React from 'react';
import { BaseIcon } from 'components';

export const CalendarIcon = (props) => {
  return(
    <BaseIcon props={props} className={`calendar-icon ${props.className || ''}`}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
        <path fillRule="evenodd" d="M6.30643 0v2.17463h9.45967V0h2.1746v2.17463h1.8847c1.201 0 2.1746.97361 2.1746 2.17463V19.3904c0 1.2011-.9736 2.1747-2.1746 2.1747H2.17463C.973615 21.5651 0 20.5915 0 19.3904V4.34926c0-1.20102.973615-2.17463 2.17463-2.17463H4.1318V0h2.17463zm9.45967 4.34926v.68863h2.1746v-.68863h1.8847v2.13838H2.17463V4.34926H4.1318v.68863h2.17463v-.68863h9.45967zM2.17463 8.66227V19.3904H19.8254V8.66227H2.17463z" clipRule="evenodd"/>
        <path d="M3.91433 10.8369h3.26195v2.1746H3.91433v-2.1746zM3.91433 15.1862h3.26195v2.1746H3.91433v-2.1746zM9.35091 10.8369h3.26199v2.1746H9.35091v-2.1746zM9.35091 15.1862h3.26199v2.1746H9.35091v-2.1746zM14.7875 10.8369h3.2619v2.1746h-3.2619v-2.1746zM14.7875 15.1862h3.2619v2.1746h-3.2619v-2.1746z"/>
      </svg>
    </BaseIcon>
  )
};
